import React from 'react';
import PropTypes from 'prop-types';
import template from '../../../../templates/Stones/AssignPricing/PricingPresets/newPreset.rt';
import { connect } from 'react-redux';
import { getPricingAlgorithmIcons } from '../../../../utilities/helpers';
import * as actions from '../../../../actions';
import _ from 'lodash';
import { setSingletonTimeout } from '../../../../utilities/helpers';

function mapStateToProps(state, props) {
  return {
    icons: getPricingAlgorithmIcons(),
    preset: state.pricingPreset.selectedPreset
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    updateValue: (field, value) => dispatch(actions.pricingPresets.updateValue(field, value)),
    toPage: ownProps.toPage
  };
}
class newPreset extends React.Component {
  render = template;
  constructor(props) {
    super(props);
    let name = (props.preset && props.preset.name) || ''
      , icon = (props.preset && props.preset.icon) || '';
    
    this.state = {
      name,
      icon
    }
  }
  
  /**
   * Sets the Preset Name
   * @param {react event} e
   */
  setName = (e) => { 
    let name = e.target.value;
    this.setState({name});
    if(this._nameTimeout) window.clearTimeout(this._nameTimeout);
    this._nameTimeout = window.setTimeout(() => this.props.updateValue('name', name), 500);
  }

  /**
   * Sets the Preset Icon
   * @param {string} icon
   */
  setIcon = (icon) => {
    this.setState({icon}, () => {
      this.props.updateValue('icon', icon);
    });
  }

  /**
   * returns converted icon's active file path
   * @param {string} icon
   * @param {string} iconFilename
   * @returns {string}
   */
  getActiveFilePath = (icon, iconFilename) => {
    if(icon == iconFilename) {
      return iconFilename.replace('pricing-algorithm-icons', 'pricing-algorithm-icons/active');
    }
    return iconFilename;
  }
}

newPreset.propTypes = {
  toPage: PropTypes.func.isRequired
};

const NewPreset = connect(mapStateToProps, mapDispatchToProps)(newPreset);

export default NewPreset;
